import * as React from 'react';
import NoResults from '../NoResults';
import { FiltersProvider } from '../../contexts/filters';
import { PostsProvider } from '../../contexts/posts';
import PostsGrid from '../PostsGrid';
import Posts from '../Posts';
import Pagination from '../PaginationNumbers';
import SearchBar from '../SearchBar';
import Search from '../filters/Search';
import ResultCount from '../ResultCount';

const LayoutSearch = () => {
	return (
		<>
			<FiltersProvider>
				<SearchBar>
					<Search />
				</SearchBar>
				<PostsProvider>
					<Posts>
						<ResultCount foundPosts={0} />
						<PostsGrid posts={[]} />
						<Pagination page={0} maxNumPages={0} />
						<NoResults posts={[]} />
					</Posts>
				</PostsProvider>
			</FiltersProvider>
		</>
	);
};

LayoutSearch.displayName = 'LayoutSearch';

export default LayoutSearch;
